import React from "react";
import moment from "moment";
import MarketTableSkeleton from "./MarketTableSkeleton";

const formatCap = (capNumber) => {
  return "$" + capNumber.toLocaleString("en-US", { maximumFractionDigits: 0 });
};

const MarketTable = ({ olswapData, olswapStats, osmosisPoolData }) => {
  if (!olswapData || !osmosisPoolData) {
    return <MarketTableSkeleton />;
  }

  const calculateVariation = (data, days) => {
    const filteredData = days
      ? data.filter((d) => d.date >= moment().subtract(days, "days").valueOf())
      : data;
    if (filteredData.length === 0) return "N/A";
    const openPrice = filteredData[0].open;
    const closePrice = filteredData[filteredData.length - 1].close;
    return ((closePrice - openPrice) / openPrice) * 100;
  };

  const filteredData = olswapData.filter((item) =>
    moment(item.date).isAfter(moment().subtract(1, "days"))
  );
  const volume = filteredData.reduce((acc, data) => acc + data.volume, 0);

  const variations = {
    "24h": calculateVariation(olswapData, 1),
    "7d": calculateVariation(olswapData, 7),
    "1m": calculateVariation(olswapData, 30),
    all: calculateVariation(olswapData, null),
  };

  const numberColor = (number) => {
    return number == null
      ? "text-gray-500"
      : number >= 0
      ? "text-green-500"
      : "text-red-500";
  };

  const tokens = [
    {
      market: "0Lswap",
      price: parseFloat(olswapStats.lastTransactionPrice),
      variation: variations,
      volume: volume,
    },
    {
      market: "Osmosis",
      price: osmosisPoolData.price,
      volume: osmosisPoolData.volume_24h,
    },
  ];

  return (
    <div className="flex overflow-hidden w-full justify-center mb-8">
      <div className="shadow-md flex-shrink-0">
        <table className="min-w-max bg-white text-sm text-gray-600">
          <thead className="bg-gray-100">
            <tr>
              <th className="text-center p-4">Market</th>
              <th className="text-center p-4">Price</th>
            </tr>
          </thead>
          <tbody>
            {tokens.map((token, index) => (
              <tr key={index} className="border-b">
                <td className="p-4">{token.market}</td>
                <td className="p-4 font-bold">
                  {token.price ? `$${token.price.toFixed(6)}` : "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex-1 overflow-x-auto whitespace-nowrap max-w-max">
        <table className="min-w-max bg-white text-sm text-gray-600">
          <thead className="bg-gray-100">
            <tr>
              <th className="text-center p-4">Volume(24h)</th>
              <th className="text-center p-4">24h %</th>
              <th className="text-center p-4">7d %</th>
              <th className="text-center p-4">30d %</th>
              <th className="text-center p-4">All %</th>
            </tr>
          </thead>
          <tbody>
            {tokens.map((token, index) => (
              <tr key={index} className="border-b">
                <td className="p-4 font-bold">
                  {token.volume ? formatCap(token.volume) : "N/A"}
                </td>
                <td
                  className={`${
                    token.variation && numberColor(token.variation["24h"])
                  } font-bold p-4`}
                >
                  {token.variation
                    ? token.variation["24h"].toFixed(2) + "%"
                    : "N/A"}
                </td>
                <td
                  className={`${
                    token.variation && numberColor(token.variation["7d"])
                  } font-bold p-4`}
                >
                  {token.variation
                    ? token.variation["7d"].toFixed(2) + "%"
                    : "N/A"}
                </td>
                <td
                  className={`${
                    token.variation && numberColor(token.variation["1m"])
                  } font-bold p-4`}
                >
                  {token.variation
                    ? token.variation["1m"].toFixed(2) + "%"
                    : "N/A"}
                </td>
                <td
                  className={`${
                    token.variation && numberColor(token.variation["all"])
                  } font-bold p-4`}
                >
                  {token.variation
                    ? token.variation["all"].toFixed(2) + "%"
                    : "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MarketTable;
